angular.module('rjmNg.common.api').factory 'AbstractConnections', [
  "$resource"
  "serviceUrl"
  "CONNECTIONS"
  (
    $resource,
    serviceUrl,
    CONNECTIONS
  ) ->

    defaultPareModelFn = (model) ->
      display_name: if model.display_name then model.display_name else model.name
      name: model.name
      properties: model.properties
      credentials: model.credentials
      type: model.type
      tokens: model.tokens

    getActions = (clientId, namespace) ->

      connectionsv2BaseUrl = "/v2/clients/#{clientId}/connections/#{namespace}"
      connectionsBaseUrl = "/clients/#{clientId}/connections/#{namespace}"
      integrationsBaseUrl = "/clients/#{clientId}/integrations/connections"

      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        getAll: angular.extend {}, defaultParams,
          method: 'GET'
          isArray: true
          url: serviceUrl(connectionsv2BaseUrl + "")
        get: angular.extend {}, defaultParams,
          method: 'GET'
          isArray: false
          url: serviceUrl(connectionsv2BaseUrl + "/:id")
          id: '@id'
        save: angular.extend {}, defaultParams,
          method: 'PUT'
          url: serviceUrl(connectionsv2BaseUrl + "/:id")
          id: '@id'
        create: angular.extend {}, defaultParams,
          method: 'POST'
          url: serviceUrl(connectionsv2BaseUrl + "/:id")
        delete: angular.extend {}, defaultParams,
          method: 'DELETE'
          url: serviceUrl(connectionsBaseUrl + "/:id")
          id: '@id'
        check: angular.extend {}, defaultParams,
          method: 'POST'
          url: serviceUrl(connectionsBaseUrl + "/:id/checks")
          id: '@id'
        checks: angular.extend {}, defaultParams,
          method: 'GET'
          isArray: true
          url: serviceUrl(connectionsBaseUrl + "/:id/checks")
          id: '@id'
        status: angular.extend {}, defaultParams,
          method: 'GET'
          isArray: false
          url: serviceUrl(connectionsBaseUrl + "/:id/checks/:checkId")
          id: '@id'
          checkId: '@checkId'
        tokens: angular.extend {}, defaultParams,
          method: 'GET'
          url: serviceUrl(connectionsv2BaseUrl + "/:id/tokens")
          isArray: true
          id: '@id'
        createAccount: angular.extend {}, defaultParams,
          method: 'POST'
          url: serviceUrl(connectionsBaseUrl + "/:type")
          type: '@type'
        createToken: angular.extend {}, defaultParams,
          method: 'POST'
          url: serviceUrl(connectionsv2BaseUrl + "/:id/tokens")
          isArray: false
          id: '@id'
        deleteToken: angular.extend {}, defaultParams,
          method: 'DELETE'
          url: serviceUrl(connectionsv2BaseUrl + "/:id/tokens/:tokenId")
          isArray: false
          id: '@id'
          token_id: '@tokenId'
        getProfilesArray: angular.extend {}, defaultParams,
          method: "GET"
          url: serviceUrl(integrationsBaseUrl + "/:id/:type/profiles")
          isArray: true
          id: '@id'
          type: '@type'
        getProfilesObject: angular.extend {}, defaultParams,
          method: "GET"
          url: serviceUrl(integrationsBaseUrl + "/:id/:type/profiles")
          isArray: false
          id: '@id'
          type: '@type'
        deleteTemporarySecrets: angular.extend {}, defaultParams,
          method: "DELETE"
          url: serviceUrl(integrationsBaseUrl + "/:id/temporary-secrets")
          id: "@id"
        test: angular.extend {}, defaultParams,
          method: "POST"
          url: serviceUrl(integrationsBaseUrl + "/:id/:type/profiles/test")
          id: "@id"
          type: "@type"
        validate: angular.extend {}, defaultParams,
          method: "POST"
          url: serviceUrl(integrationsBaseUrl + "/:id/:type/validate")
          id: "@id"
          type: "@type"

      return $resource(serviceUrl(connectionsBaseUrl + "/"), {}, actions)

    (clientId, namespace, pareModelFn) ->

      pareModel = if pareModelFn? then pareModelFn else defaultPareModelFn

      connections = getActions(clientId, namespace)

      get: (id = null, params = {}) ->
        requestParams = angular.extend {}, params

        if id?
          requestParams.id = id
          return connections.get(requestParams).$promise

        connections.getAll(requestParams).$promise

      save: (model, params = {}) ->
        paredModel = pareModel model
        if model.id?
          params.id = model.id
          connections.save(params, paredModel).$promise
        else
          connections.create(params, paredModel).$promise

      create: (model, params = {}) ->
        paredModel = pareModel model
        connections.create(params, paredModel).$promise

      delete: (model) ->
        connections.delete(id: model.id).$promise

      markDeleted: (model) ->
        paredModel = pareModel _.omit(model, 'tokens')
        paredModel.properties.status = CONNECTIONS.STATUS.DELETED
        connections.save(id: model.id, paredModel).$promise

      check: (model) ->
        connections.check({id: model.id}, {connection_id: model.id}).$promise

      createCheck: (model, modelCheck) ->
        check =
          connection_id: model.id
          status: modelCheck.status
          reason: modelCheck.reason
          message: modelCheck.message
        connections.check({id: model.id}, check).$promise

      checks: (model) ->
        connections.checks(id: model.id).$promise

      status: (connectionId, checkId) ->
        connections.status(id: connectionId, checkId: checkId).$promise

      tokens: (connectionId) ->
        connections.get({id: connectionId, expand_tokens: true}).$promise

      createToken: (connectionId, params) ->
        connections.createToken({id: connectionId}, params).$promise

      deleteToken: (connectionId, params) ->
        connections.deleteToken({id: connectionId, tokenId: params.token_id}).$promise

      getProfiles: (connectionId, connectionType, isArray = true) ->
        if isArray
          connections.getProfilesArray({id: connectionId, type: connectionType}).$promise
        else
          connections.getProfilesObject({id: connectionId, type: connectionType}).$promise

      deleteTemporarySecrets: (connectionId) ->
        connections.deleteTemporarySecrets({id: connectionId}).$promise

      test: (connectionId, connectionType, testRequest) ->
        connections.test({id: connectionId, type: connectionType}, testRequest).$promise

      validate: (connectionId, connectionType, params) ->
        connections.validate({id: connectionId, type: connectionType}, params).$promise

      createAccount: (model) ->
        connections.createAccount({type: model.type}, model).$promise
]
